/*eslint-disable*/ export const messages = { New: "Novo", "Remove {label}": ["Remover ", ["label"]] };
